/* EASE Rubbellos-Popup
   Alle Einstellungen kommen als data-Attribute vom Section-Markup, damit sie
   im Theme-Editor pflegbar bleiben. Laeuft ohne Abhaengigkeiten. */
(function () {
  "use strict";

  var pop = document.getElementById("easc");
  if (!pop) return;

  var d = pop.dataset;
  var num = function (v, f) { var n = parseFloat(v); return isNaN(n) ? f : n; };
  var area = (d.area || "34,55,33,24").split(",").map(Number);

  var CFG = {
    preview: d.preview === "true",
    paths: (d.paths || "/products/").split(",").map(function (s) { return s.trim(); }).filter(Boolean),
    seconds: num(d.seconds, 60),
    scrollPct: num(d.scroll, 70),
    exitIntent: d.exit === "true",
    cooldownDays: num(d.cooldown, 7),
    code: d.code || "",
    productPath: d.productPath || "/",
    company: d.company || "",
    list: d.list || "",
    source: d.source || "ease-scratch-popup",
    area: { x: area[0] / 100, y: area[1] / 100, w: area[2] / 100, h: area[3] / 100 },
    objPosY: num(d.objpos, 12) / 100,
    revealThreshold: 0.46,
    brush: 30,
    holdMs: 1600
  };

  var KEY = "ease_lead";
  var Lead = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set: function (p) {
      var s = Object.assign(Lead.get(), p, { updatedAt: Date.now() });
      try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
      return s;
    }
  };

  var bg = document.getElementById("easc-bg");
  var box = document.getElementById("easc-scratch");
  var canvas = document.getElementById("easc-foil");
  var ctx = canvas.getContext("2d", { willReadFrequently: true });
  var cue = document.getElementById("easc-cue");
  var badge = document.getElementById("easc-badge");
  var form = document.getElementById("easc-form");
  var errEl = document.getElementById("easc-err");

  var geo = { w: 0, h: 0 }, ready = false, revealed = false, drawing = false;
  var lastX = null, lastY = null, lastFocus = null, lastCheck = 0;

  function isSplit() { return window.matchMedia("(min-width: 900px)").matches; }

  /* Auf Mobil liegt die Folie ueber dem Produkt im Video. object-fit:cover
     verschiebt den sichtbaren Ausschnitt, deshalb hier nachrechnen. */
  function placeBox() {
    if (isSplit()) return true;
    var r = bg.getBoundingClientRect();
    var cw = r.width, ch = r.height;
    var nw = bg.videoWidth || 900, nh = bg.videoHeight || 1200;
    if (!cw || !ch) return false;
    var scale = Math.max(cw / nw, ch / nh);
    var dw = nw * scale, dh = nh * scale;
    var ox = r.left + (cw - dw) * 0.5;
    var oy = r.top + (ch - dh) * CFG.objPosY;
    var a = CFG.area;
    box.style.left = Math.round(ox + a.x * dw) + "px";
    box.style.top = Math.round(oy + a.y * dh) + "px";
    box.style.width = Math.round(a.w * dw) + "px";
    box.style.height = Math.round(a.h * dh) + "px";
    badge.style.left = Math.round(ox + (a.x + a.w / 2) * dw) + "px";
    badge.style.top = Math.round(oy + (a.y + a.h * 0.52) * dh) + "px";
    return true;
  }

  function drawFoil() {
    var w = geo.w, h = geo.h, r = 16;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    ctx.beginPath();
    ctx.moveTo(r, 0); ctx.lineTo(w - r, 0); ctx.quadraticCurveTo(w, 0, w, r);
    ctx.lineTo(w, h - r); ctx.quadraticCurveTo(w, h, w - r, h);
    ctx.lineTo(r, h); ctx.quadraticCurveTo(0, h, 0, h - r);
    ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0); ctx.closePath();
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, "#F2E6CC"); g.addColorStop(.3, "#DCC9A6"); g.addColorStop(.55, "#CDB694");
    g.addColorStop(.78, "#EADCC2"); g.addColorStop(1, "#BCA37C");
    ctx.fillStyle = g; ctx.fill();
    ctx.save(); ctx.clip();
    ctx.globalAlpha = .08; ctx.strokeStyle = "#6B5330"; ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 7) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + h, h); ctx.stroke(); }
    ctx.globalAlpha = .24;
    var sh = ctx.createLinearGradient(0, h * .2, w, h * .75);
    sh.addColorStop(0, "rgba(255,255,255,0)");
    sh.addColorStop(.5, "rgba(255,255,255,.9)");
    sh.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = sh; ctx.fillRect(0, 0, w, h);
    ctx.restore(); ctx.globalAlpha = 1;
  }

  function setup(force) {
    if (!placeBox()) return;
    var rect = box.getBoundingClientRect();
    if (!rect.width) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(rect.width)), h = Math.max(1, Math.round(rect.height));
    if (!force && canvas.width === w * dpr && ready) return;
    canvas.width = w * dpr; canvas.height = h * dpr;
    canvas.style.width = w + "px"; canvas.style.height = h + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    geo = { w: w, h: h }; drawFoil(); ready = true;
  }

  function scratchAt(cx, cy) {
    if (revealed || !ready) return;
    var rect = canvas.getBoundingClientRect();
    var x = cx - rect.left, y = cy - rect.top;
    ctx.globalCompositeOperation = "destination-out";
    var b = ctx.createRadialGradient(x, y, 0, x, y, CFG.brush);
    b.addColorStop(0, "rgba(0,0,0,1)"); b.addColorStop(.65, "rgba(0,0,0,.85)"); b.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = b; ctx.beginPath(); ctx.arc(x, y, CFG.brush, 0, Math.PI * 2); ctx.fill();
    if (lastX != null) {
      ctx.lineWidth = CFG.brush * 1.4; ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.strokeStyle = "rgba(0,0,0,.9)";
      ctx.beginPath(); ctx.moveTo(lastX, lastY); ctx.lineTo(x, y); ctx.stroke();
    }
    lastX = x; lastY = y;
  }

  function cleared() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var n = 0, t = 0, stride = 8 * dpr * 4;
    for (var i = 3; i < data.length; i += stride) { t++; if (data[i] < 48) n++; }
    return t ? n / t : 0;
  }

  function maybeReveal() {
    if (revealed || cleared() < CFG.revealThreshold) return;
    revealed = true;
    cue.classList.add("is-hidden");
    box.classList.add("is-done");
    box.style.opacity = "0";
    badge.classList.add("is-on");
    try { bg.currentTime = 0; var pr = bg.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    setTimeout(function () { badge.classList.remove("is-on"); }, CFG.holdMs);
    setTimeout(function () { showStep("email"); }, CFG.holdMs + 380);
  }

  function showStep(name) {
    var steps = pop.querySelectorAll(".easc__step");
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.toggle("is-active", steps[i].getAttribute("data-step") === name);
    }
    if (name !== "scratch") badge.classList.remove("is-on");
    /* Beim Rubbeln bleibt der Verlauf tief, damit vom Bild moeglichst viel steht.
       Ab dem Formular faehrt er hoch, dort zaehlt Lesbarkeit mehr als das Motiv. */
    pop.classList.toggle("is-lifted", name !== "scratch");
    var f = pop.querySelector(".easc__step.is-active input, .easc__step.is-active button:not([data-easc-close])");
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 70);
  }

  canvas.addEventListener("pointerdown", function (e) {
    drawing = true; lastX = lastY = null; cue.classList.add("is-hidden");
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    scratchAt(e.clientX, e.clientY);
  });
  /* Waehrend der Bewegung pruefen, nicht erst beim Loslassen. Gedrosselt,
     weil cleared() die komplette Maske liest. */
  canvas.addEventListener("pointermove", function (e) {
    if (!drawing) return;
    scratchAt(e.clientX, e.clientY);
    var now = Date.now();
    if (now - lastCheck > 120) { lastCheck = now; maybeReveal(); }
  });
  ["pointerup", "pointercancel", "pointerleave"].forEach(function (t) {
    canvas.addEventListener(t, function () {
      if (!drawing) return;
      drawing = false; lastX = lastY = null; maybeReveal();
    });
  });
  canvas.addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });

  function subscribe(email) {
    if (!CFG.company || !CFG.list) return Promise.resolve({ skipped: true });
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(CFG.company), {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2026-07-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: email, properties: { ease_welcome_code: CFG.code, ease_source: CFG.source } }
              }
            }
          },
          relationships: { list: { data: { type: "list", id: CFG.list } } }
        }
      })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error("klaviyo " + r.status); return r; });
  }

  function discountUrl() {
    return "/discount/" + encodeURIComponent(CFG.code) + "?redirect=" + encodeURIComponent(CFG.productPath);
  }

  /* Zielpfad ohne Query und Anker, zum Vergleich mit der aktuellen Adresse. */
  function targetPath() {
    return CFG.productPath.split("?")[0].split("#")[0];
  }

  function onTargetPage() {
    return location.pathname.replace(/\/$/, "") === targetPath().replace(/\/$/, "");
  }

  function prefetch(url) {
    if (!url || document.querySelector('link[rel="prefetch"][href="' + url + '"]')) return;
    var l = document.createElement("link");
    l.rel = "prefetch";
    l.href = url;
    document.head.appendChild(l);
  }

  /* Shopify setzt beim Aufruf von /discount/CODE ein Cookie. Ein Hintergrundaufruf
     genuegt, der Gast bleibt auf der Seite. Der Button geht denselben Weg, falls
     der Aufruf blockiert wurde. */
  function activateDiscount() {
    var go = document.getElementById("easc-go");
    if (go) go.setAttribute("href", discountUrl());
    if (!CFG.code) return;
    fetch(discountUrl(), { credentials: "same-origin" }).then(function () {
      /* Cookie sitzt. Ab jetzt direkt aufs Ziel statt ueber den Redirect: spart
         einen Hop und laesst sich im Gegensatz zum Redirect vorladen. */
      if (go) go.setAttribute("href", CFG.productPath);
      if (!onTargetPage()) prefetch(CFG.productPath);
    }).catch(function () {});
  }

  /* Das Popup liegt als Overlay auf der Produktseite. Zeigt der CTA auf genau diese
     Seite, waere ein Reload nur Wartezeit: schliessen reicht, der Rabatt haengt
     bereits im Cookie. */
  var goBtn = document.getElementById("easc-go");
  if (goBtn) {
    goBtn.addEventListener("click", function (e) {
      if (!onTargetPage()) return;
      e.preventDefault();
      hide();
    });
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      errEl.textContent = "";
      var email = (form.email.value || "").trim();
      var consent = document.getElementById("easc-consent");
      /* Ohne Haken wird nichts abgeschickt. Fehlt das Element ganz, blockieren wir
         ebenfalls: keine Einwilligung ohne nachweisbares Opt-in. */
      if (!consent || !consent.checked) {
        errEl.textContent = "Bitte bestätige die Einwilligung.";
        if (consent) consent.focus();
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.textContent = "Bitte prüfe deine E-Mail-Adresse.";
        return;
      }
      var btn = form.querySelector("button[type=submit]");
      btn.disabled = true;
      subscribe(email)
        .catch(function (err) {
          /* Der Gast hat geliefert, den Code bekommt er in jedem Fall.
             Faellt Klaviyo aus, merken wir die Adresse fuer den naechsten Aufruf. */
          if (window.console) console.warn("[ease-scratch] Klaviyo:", err);
          Lead.set({ pendingEmail: email });
        })
        .then(function () {
          Lead.set({ subscribed: true, source: CFG.source });
          activateDiscount();
          showStep("code");
        })
        .finally(function () { btn.disabled = false; });
    });
  }

  (function retryPending() {
    var p = Lead.get().pendingEmail;
    if (!p) return;
    subscribe(p).then(function (r) { if (!(r && r.skipped)) Lead.set({ pendingEmail: null }); }).catch(function () {});
  })();

  function open() {
    lastFocus = document.activeElement;
    /* Ziel schon beim Oeffnen vorladen, nicht erst nach dem Rubbeln: bis der Gast
       am CTA ankommt, liegt die Seite im Cache. */
    if (!onTargetPage()) prefetch(CFG.productPath);
    pop.hidden = false;
    pop.classList.add("is-open");
    document.body.style.overflow = "hidden";
    try { bg.pause(); bg.currentTime = 0; } catch (e) {}
    var go = function () { setup(true); };
    if (bg.readyState >= 1) requestAnimationFrame(go); else bg.addEventListener("loadedmetadata", go, { once: true });
    setTimeout(function () { try { pop.focus({ preventScroll: true }); } catch (e) {} }, 90);
  }

  /* Nur wegblenden, ohne Zustand. Der CTA-Weg nutzt das: wer eingeloest hat, ist
     kein Abbrecher und darf nicht als solcher im Speicher landen. */
  function hide() {
    pop.classList.remove("is-open");
    pop.hidden = true;
    document.body.style.overflow = "";
    if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function close() {
    hide();
    Lead.set({ lastDismissedAt: Date.now(), sessionInterrupt: true });
  }

  pop.addEventListener("click", function (e) {
    if (e.target.closest("[data-easc-close]")) close();
  });
  document.addEventListener("keydown", function (e) {
    if (!pop.classList.contains("is-open")) return;
    if (e.key === "Escape") close();
    if (e.key === "Tab") {
      var f = pop.querySelectorAll("button:not([disabled]), input, a[href]");
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  var copy = document.getElementById("easc-copy");
  if (copy) {
    copy.addEventListener("click", function () {
      var b = this, old = b.textContent;
      function done() { b.textContent = "kopiert"; setTimeout(function () { b.textContent = old; }, 1500); }
      if (navigator.clipboard) navigator.clipboard.writeText(CFG.code).then(done).catch(done); else done();
    });
  }

  var rt;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(function () { if (!revealed) setup(true); else placeBox(); }, 160);
  });

  function eligible() {
    var s = Lead.get();
    if (s.subscribed || s.sessionInterrupt) return false;
    if (s.lastDismissedAt && (Date.now() - s.lastDismissedAt) / 86400000 < CFG.cooldownDays) return false;
    if (CFG.preview) return true;
    for (var i = 0; i < CFG.paths.length; i++) {
      if (location.pathname.indexOf(CFG.paths[i]) !== -1) return true;
    }
    return false;
  }

  function armTriggers() {
    if (!eligible()) return;
    var fired = false, timer = null;
    var wait = CFG.preview ? 3 : CFG.seconds;

    function off() {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onLeave);
    }
    /* Der Kaufblock ist der wertvollste Slot der Seite. Solange er im Bild ist,
       wird nicht geoeffnet, sondern nachgefasst. Greift fuer alle drei Trigger,
       deshalb sitzt der Guard hier und nicht in den einzelnen Handlern. */
    function atcInView() {
      var els = document.querySelectorAll('[data-ease-cta], [name="add"]');
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        /* body traegt ease-sticky-atc-bar-enabled, deshalb hier exakte Wurzeln statt Substring. */
        if (el.closest('.ease-sticky-atc-bar, .ease-sticky-atc-drawer')) continue;
        if (el.offsetParent === null) continue;
        var r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) return true;
      }
      return false;
    }
    function fire(why) {
      if (fired) return;
      if (atcInView()) {
        clearTimeout(timer);
        timer = setTimeout(function () { fire(why); }, 4000);
        return;
      }
      fired = true; off();
      Lead.set({ lastTriggerReason: why });
      open();
    }
    function onScroll() {
      var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if ((window.scrollY / h) * 100 >= CFG.scrollPct) fire("scrolltiefe");
    }
    /* Exit-Intent nur mit echtem Zeiger. Die Zurueck-Taste fangen wir bewusst nicht ab. */
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 4) fire("exit-intent"); }

    timer = setTimeout(function () { fire("zeit"); }, wait * 1000);
    window.addEventListener("scroll", onScroll, { passive: true });
    if (CFG.exitIntent && window.matchMedia("(pointer: fine)").matches) {
      document.addEventListener("mouseout", onLeave);
    }
  }

  armTriggers();
})();
